import { PHASE_PRODUCTION_BUILD } from 'next/constants.js';
import type { ChildLoggerOptions, Logger, LoggerOptions } from 'pino';
import createPinoLogger from 'pino';
import { env } from '@/env';

const enablePrettyPrint = process.env['NODE_ENV'] !== 'production' || PHASE_PRODUCTION_BUILD === process.env.NEXT_PHASE;
const options: LoggerOptions = enablePrettyPrint
    ? {
          transport: {
              target: 'pino-pretty',
              options: {
                  colorize: true,
              },
          },
          level: 'debug',
          hooks: {
              logMethod(args, method) {
                  // Replace internal docker URL with localhost so we can click links in the console
                  if (env.ENV === 'dev') {
                      for (let i = 0; i < args.length; i++) {
                          if (typeof args[i] === 'string') {
                              args[i] = (args[i] as string).replace(env.CMS_API_INTERNAL_BASE_URL, `(${env.CMS_API_INTERNAL_BASE_URL})http://localhost:9001`);
                          }
                      }
                  }
                  return method.apply(this, args);
              },
          },
      }
    : {
          level: 'info',
      };

const logger: Logger = createPinoLogger(options);

export function createLogger(name: string, options: ChildLoggerOptions = {}): Logger {
    return logger.child({ name }, options);
}
